(function ($, Drupal) {

  "use strict";

  Drupal.behaviors.sidebarMenu = {
    attach: function (context, settings) {

      $('.sidebar-menu__heading', context).click(function() {
        const $heading = $(this);
        const $menu = $(this).next();

        if ($(this).hasClass('is-active')) {
          $menu.slideUp(function() {
            $heading.removeClass('is-active');
          });
        }
        else {
          $menu.slideDown(function() {
            $heading.addClass('is-active');
          })
        }
      });
    }
  };

})(jQuery, Drupal);
